<template>
    <transition name="fade-slide-left" mode="out-in" appear >
        <div class="warning--bar display--flex background--white shadow--default">
            <icon-success v-if="settings.status === 'success'" class="warning--bar__svg" />
            <icon-error v-else class="warning--bar__svg"  />
            <span class="warning--bar__text">
                {{ settings.message }}
            </span>
        </div>
    </transition>
</template>

<script>
export default {
    components: {
        IconSuccess: () => import( /* webpackChunkName: 'IconSuccess' */ '@/components/bundles/layout/images/icons/IconSuccess' ),
        IconError: () => import( /* webpackChunkName: 'IconError' */ '@/components/bundles/layout/images/icons/IconError' )
    },
    props: {
        settings: Object
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    @include keyframes ( fadeIn ) {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    // =============================================================================
    // Style
    // =============================================================================
    .warning {
        &--bar {
            align-items: center;
            width: 100%;
            min-width: 320px;
            min-height: 73px;
            padding: 22px 30px;
            @include rounded-corner( 11px );
            z-index: 8;
            &__svg {
                margin-right: 15px;
                @include dimensions( 28px );
            }
            &__text {
                width: calc( 100% - 43px );
                @include animation( fadeIn .6s ease-in-out );
            }
        }
    }
</style>